import about from '../../components/about.vue';
const PopupBox = window.vue.$mainVue.extend(about);

let instance = new PopupBox({}).$mount();

about.install = function(title) {
    if (!instance.dialogAboutVisible) {
        document.body.appendChild(instance.$el);
    }
    window.vue.$mainVue.nextTick(() => {
        if (!instance.dialogAboutVisible) {
            instance.initData(title);
        }
    });
};
export default about;
